module.exports = __webpack_public_path__ + "static/media/wardrobe 1.93902180.jpeg";